import { Component, ElementRef, Input, OnInit, SecurityContext, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { WebapiService } from '../webapi.service';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-aichat',
  templateUrl: './aichat.component.html',
  styleUrls: ['./aichat.component.scss'],
})
export class AichatComponent implements OnInit {
  @ViewChild('chatContainer') private chatContainer!: ElementRef;
  private controller: AbortController | null = null;

  messages:any= [];

  welcome_msg="📈🔎 What you’d like to analyze today"
  isOpen = false;
  userInput = '';
  selectedmodule:any;
  config_list:any=[]
  role:any=""
  botlist:any=[];
  constructor(private router:Router,private service:WebapiService,private sanitizer: DomSanitizer) {
        this.role=localStorage.getItem('role');

   }
  type=""

  scrollToBottom() {
  try {
    setTimeout(() => {

    this.chatContainer.nativeElement.scrollTop =
      this.chatContainer.nativeElement.scrollHeight;
      }, 50);
  } catch (err) {}
}
  toggleChat() {
    this.isOpen = !this.isOpen;
  }
  private currentAbortController: AbortController | null = null;
// A map to store and manage timeouts for each chat session
loadingTimeouts = new Map<number, any>();
// This will hold a unique ID for the current chat session
currentChatId: number = 0;


  ngOnInit() {
    this.getall_botlist();

  }



  ///functions 

  handleDynamicClick(event: Event) {
    const target = event.target as HTMLElement;
 // alert(target.tagName+","+ target.classList.toString())

    if (target.tagName === 'SPAN' && target.classList.contains('btn')) {
        const index = target.getAttribute('data-index');
       // alert(index)
        if (index !== null) {
            this.setmodule(Number(index));

            
        }
    }
}
private botListAbortController: AbortController | null = null;

flag=false;
getall_botlist() {
  this.flag=false;
    // Abort any previous bot list request
    if (this.botListAbortController) {
        this.botListAbortController.abort();
    }

    const newAbortController = new AbortController();
    this.botListAbortController = newAbortController;
    const signal = newAbortController.signal;

    const thisChatId = ++this.currentChatId;

    // Push a temporary loading message for the user's question
    const loadingMessageIndex = this.messages.length;
    this.messages.push({
        msgby: 'bot',
        msg: '⏳ Thinking..',
        timestamp: new Date(),
        chatId: thisChatId,
        isTemp: true
    });
    this.scrollToBottom();

    this.config_list = [];
    var action="getactivated_bot_config"
    if(this.type!="")
    {
        action="getactivated_bot_config_type"
    }


    this.service.postData({ type: this.type },action).then((result) => {
        if (this.messages[loadingMessageIndex]?.chatId === thisChatId) {
            this.botListAbortController = null; // Clear the controller on successful completion
            const temp: any = result;
            this.config_list = temp.data;
            let names = "";
            this.botlist=result.data;
            this.flag=true;
            if(this.config_list.length>0)
            {

              //  this.selectedmodule = this.config_list[2];
            this.setmodule(2);
            // this.config_list.forEach((element, index) => {
            //     names += `<span class="btn" style=" display: inline-block;word-break: break-word;line-height: 1.4;border-radius: 5px;border: thin solid gray;margin: 5px;background-color:#077dbc;color:#fff;padding:2px;cursor:pointer" data-index="${index}">${element.sName}</span>`;
            // });
            const botMessageHtml = `<div style="margin-bottom:10px">${this.welcome_msg}</div>`;
            // Update the temporary message with the final response
            this.messages[loadingMessageIndex] = {
                msgby: 'bot',
                msg: this.sanitizer.bypassSecurityTrustHtml(botMessageHtml),
                timestamp: new Date(),
                chatId: thisChatId
            };
           }
           else{
             const botMessageHtml = `<div style="margin-bottom:10px">Sorry,No module yet configured to chat.</div> `;
            // Update the temporary message with the final response
            this.messages[loadingMessageIndex] = {
                msgby: 'bot',
                msg: this.sanitizer.bypassSecurityTrustHtml(botMessageHtml),
                timestamp: new Date(),
                chatId: thisChatId
            };
           }
            this.scrollToBottom();
        }
    }).catch(e => {
        if (e.name === 'AbortError') {
            console.log('Bot list request was aborted.');
            return;
        }
        // If there's an error and the message still exists, update it
        if (this.messages[loadingMessageIndex]?.chatId === thisChatId) {
            this.messages[loadingMessageIndex] = {
                msgby: 'bot',
                msg: 'Oops! Unable to load the bot list. Please try again later.',
                timestamp: new Date(),
                chatId: thisChatId
            };
            this.scrollToBottom();
        }
        this.botListAbortController = null;
    });
}
setque(text)
{
  this.userInput=text;
}
groupHintsByType(hintList: { question: string; type?: string }[]) {
  const groups: any = {};

  hintList.forEach(h => {
    const typeName = h.type && h.type.trim() !== '' ? h.type : 'Others';

    if (!groups[typeName]) {
      groups[typeName] = { open: false, questions: [] };
    }

    groups[typeName].questions.push(h);
  });

  // Convert to sorted object with Others at bottom
  const ordered: any = {};

  Object.keys(groups)
    .filter(k => k !== 'Others')
    .sort()                        // optional alphabetical ordering
    .forEach(k => ordered[k] = groups[k]);

  // Add Others at the end (if exists)
  if (groups['Others']) {
    ordered['Others'] = groups['Others'];
  }

  return ordered;
}
toggleType(type: string) {
  this.hintGroups[type].open = !this.hintGroups[type].open;
}
hintGroups:any=[]
hintList:any=[]
   setmodule(x: number) {
    this.selectedmodule = this.config_list[x];
    console.log(this.selectedmodule)
    this.hintList=JSON.parse(this.selectedmodule.shintquestion);
     this.hintGroups = this.groupHintsByType(this.hintList);

      
    // const thisChatId = ++this.currentChatId;

    // // Push the user's message indicating which module was selected
    // this.messages.push({
    //     msgby: 'user',
    //     msg: this.sanitizer.bypassSecurityTrustHtml(`<div>${this.selectedmodule.sName}</div>`),
    //     timestamp: new Date(),
    //     chatId: thisChatId
    // });

    // // Push the bot's descriptive message
    // this.messages.push({
    //     msgby: 'bot',
    //     msg: this.sanitizer.bypassSecurityTrustHtml(this.selectedmodule.sdescription),
    //     timestamp: new Date(),
    //     chatId: thisChatId
    // });
    // this.scrollToBottom();
  }

  // chat

  chartData = {
      "chartType": "ColumnChart",
      "dataTable": [
          ["Lane", "Backlog (kg)"],
          ["HKG - GDL", 90468.0],
          ["HKG - HKG", 40437.5],
          ["HKG - ELP", 28905.5],
          ["HKG - DFW", 26141.5],
          ["HAN - HKG", 21339.0]
      ],
      "options": {
          "title": "Top 5 Lanes by Backlog Weight",
          "hAxis": {
              "title": "Lane"
          },
          "vAxis": {
              "title": "Backlog Weight (kg)",
              "format": "#,###"
          },
          "legend": {
              "position": "none"
          }
      }
  };
  
  chartlist:[]
  
  apiTime: string = '';
  apiLiveSeconds: string = '';
  apiResponse: any;
  loading: boolean = false;
private intervalId: any;
 isValidJSON(str) {
  try {
    JSON.parse(str);
    return true;
  } catch (e) {
    return false;
  }
}
activereq=null
  chat(q: string) {


        this.controller = new AbortController();

    
      if (!this.selectedmodule) {
          this.messages.push({
              msgby: 'bot',
              msg: 'Please select a module to begin our conversation.',
              timestamp: new Date()
          });
          return;
      }
  
      var cleaned = this.sanitizeUserInput(q);
  
          const thisChatId = ++this.currentChatId;
  
      if (!this.isValidUserInput(cleaned)) {
          
       // alert("Invalid input detected!");
        this.messages.push({
              msgby: 'bot',
              msg: 'Please enter a valid query.No html,js tags and special characters are allowd',
              timestamp: new Date()
          });
        return;
      }
  
    
      this.messages.push({
          msgby: 'user',
          msg: cleaned,
          timestamp: new Date(),
          chatId: thisChatId
      });
    this.apiTime = '';
    this.apiLiveSeconds = '';
    this.loading = true;
      const loadingMessageIndex = this.messages.length;
      this.messages.push({
          msgby: 'bot',
          msg: '⏳ Thinking..',
          apitime:this.apiTime,
          apiLiveSeconds:this.apiLiveSeconds,
          timestamp: new Date(),
          chatId: thisChatId,
          isTemp: true
      });
        

    const start = performance.now();
    const startTime = Date.now();   // For seconds timer

    // Start live seconds counter
        this.intervalId = setInterval(() => {
          const diff = (Date.now() - startTime) / 1000; // seconds
          this.apiLiveSeconds = diff.toFixed(1) + "";
          this.messages[loadingMessageIndex].msg= "⏳ Thinking..("+this.apiLiveSeconds+") sec"; 
        }, 100); // update every 0.1s
      this.scrollToBottom();
  
      var prompt = this.selectedmodule.sotherprompt;      
      var tech_prompt = this.selectedmodule.stechprompt;

      const fixedJSON = JSON.parse(this.selectedmodule.sjsonconfig).replace(/\bNaN\b/g, 'null');
      var sjsonconfig = fixedJSON;
      prompt += "CSV FILE METADATA:" + JSON.stringify(JSON.parse(fixedJSON));
      // prompt += " Technical instruction to generate python code : " + this.selectedmodule.stechprompt;
  
      // this.loadingTimeouts.set(thisChatId, setTimeout(() => {
      //     if (this.messages[loadingMessageIndex]?.chatId === thisChatId) {
      //         this.messages[loadingMessageIndex].msg = 'This is taking a bit longer than usual. Please hang on...';
      //         this.scrollToBottom();
      //     }
      // }, 10000));
  
     this.activereq= this.service.postData_cancel({'query': cleaned, 'prompt': prompt, 'tech_prompt': tech_prompt, 'timeout': 180}, 'analyze_new_timeout_new');
    this.activereq.promise .then((result) => {
              clearTimeout(this.loadingTimeouts.get(thisChatId));
              this.loadingTimeouts.delete(thisChatId);
  
              // console.log(this.cleanGoogleChartTag(result.natural_response));
              if (this.messages[loadingMessageIndex]?.chatId === thisChatId) {
  
                   if(result.type=='json')
                     {
                          
                     }
                  //  var res:any=this.extractAndRemoveCharts(this.cleanGoogleChartTag(result.natural_response))
                  //  console.log(res.data);
                  //  console.log(res.cleanedHtml);
                  var jsondata=""
                  if(this.isValidJSON(result.json_result))
                     jsondata=this.convertJsonToHtml(JSON.parse(result.json_result))
                  this.finishTimer(start);
                  this.messages[loadingMessageIndex] = {
                      msgby: 'bot',
                      msg: result.natural_response,
                      code:result.code,
                      mode:result.mode,
                      response:result.response,
                      type:result.type,
                      apiTime:this.apiTime,
                      dflen:result.dflen,
                      download:result.json_data,
                      download_json:jsondata,
                      charts:[],
                      timestamp: new Date(),
                      chatId: thisChatId
                  };
                  console.log(this.messages[loadingMessageIndex]);
                  this.scrollToBottom();
              }
                    

          })
          .catch(res => {
              if (res.name === 'AbortError') {
                  console.log('Request was aborted by a new user message or start over.');
                  clearTimeout(this.loadingTimeouts.get(thisChatId));
                  this.loadingTimeouts.delete(thisChatId);
                  return;
              }
              
              console.error('API Error:', res);
              clearTimeout(this.loadingTimeouts.get(thisChatId));
              this.loadingTimeouts.delete(thisChatId);
  
              if (this.messages[loadingMessageIndex]?.chatId === thisChatId) {
                  this.messages[loadingMessageIndex] = {
                      msgby: 'bot',
                      msg: 'Oops! Something went wrong. Please try again.',
                      timestamp: new Date(),
                      chatId: thisChatId
                  };
                  this.scrollToBottom();
              }
                this.finishTimer(start);

          })
          .finally(() => {
              this.currentAbortController = null;
          });
  }

  cancelRunningApi() {
  if (this.activereq) {
    this.activereq.cancel();
    this.activereq = null;
  }
  // Stop timer if running
  if (this.intervalId) {
    clearInterval(this.intervalId);
    this.intervalId = null;
  }

  // Optional: show cancel message
  this.messages.push({
    msgby: 'bot',
    msg: '❌ Request cancelled.',
    timestamp: new Date()
  });

  this.loading = false;
}

  
  finishTimer(start: number) {
  const end = performance.now();
  const totalMs = (end - start).toFixed(2);
  const totalSec = (Number(totalMs) / 1000).toFixed(2);

  this.apiTime = `${totalSec} sec`;

  this.loading = false;

  clearInterval(this.intervalId); // Stop live timer
}
    sendMessage() {
      console.log(this.userInput)
      if (this.userInput.trim() !== '') {
        // this.messages.push({
        //   msgby: 'user',
        //   msg: this.userInput,
        //   timestamp: new Date()
        // });
  
        this.chat( this.userInput);
        // const botResponse = `You said: ${this.userInput}`;
        // setTimeout(() => {
        //   this.messages.push({
        //     msgby: 'bot',
        //     msg: botResponse,
        //     timestamp: new Da
        // te()
        //   });
        // }, 500);
  
        this.userInput = '';
      }
    }
  
    cleanGoogleChartTag(htmlString: string): string {
    // Regex to find the <google-chart> tag and its data attribute.
    // The 's' flag allows '.' to match newline characters.
    const regex = /(<google-chart\s+\[data\]=")([^"]*)("><\/google-chart>)/s;
  
    // Use the replace method with a replacer function to capture and clean the content.
    return htmlString.replace(regex, (match, p1, p2, p3) => {
      // p1: The opening part of the tag (e.g., "<google-chart [data]=").
      // p2: The raw content of the [data] attribute (the data object string).
      // p3: The closing part of the tag (e.g., "></google-chart>").
  
      // Clean the captured data by replacing all whitespace characters (\s)
      // with an empty string globally (g).
      const cleanedData = p2.replace(/\s+/g, '');
  
      // Reconstruct the tag with the cleaned data and return it.
      return `${p1}${cleanedData}${p3}`;
    });
  
    
  }
  
  
   extractAndRemoveCharts(htmlString) {
      const dataArray = [];
      // Regex to find the data attribute content more robustly
      const extractRegex = /<google-chart\s+\[data\]="([^"]*)"[^>]*>/gs;
      let match;
  
      while ((match = extractRegex.exec(htmlString)) !== null) {
          let rawDataString = match[1];
  
          try {
              // Replace known HTML entities and single quotes
              rawDataString = rawDataString.replace(/&quot;/g, '"');
              rawDataString = rawDataString.replace(/'/g, '"');
  
              const chartData = JSON.parse(rawDataString);
              dataArray.push(chartData);
          } catch (e) {
              console.error('Failed to parse JSON data from a <google-chart> tag:', e);
              console.error('Problematic string:', rawDataString);
          }
      }
      
      // Regex to remove the entire <google-chart> tag
      const removeRegex = /<google-chart\s+\[data\]="[^"]*"[^>]*><\/google-chart>/gs;
      const cleanedHtml = htmlString.replace(removeRegex, '').trim();
  
      return {
          data: dataArray,
          cleanedHtml: cleanedHtml,
      };
  }
   sanitizeUserInput(input: string): string {
    if (!input) return "";
  
    // 1. Trim whitespace
    let sanitized = input.trim();
  
    // 2. Remove HTML tags
    sanitized = sanitized.replace(/<[^>]*>/g, "");
  
    // 3. Block suspicious characters often used in injections
    sanitized = sanitized.replace(/[{};$<>]/g, "");
  
    // 4. Limit length (avoid DoS by very large input)
    const MAX_LENGTH = 500;
    if (sanitized.length > MAX_LENGTH) {
      sanitized = sanitized.substring(0, MAX_LENGTH);
    }
  
    return sanitized;
  }
  
  // Validation example
    isValidUserInput(input: string): boolean {
    if (!input) return false;
  
    // Reject empty or too short input
    if (input.trim().length < 2) return false;
  
    // Reject if contains SQL/JS keywords (basic filter)
    const blacklist = /(SELECT|INSERT|DELETE|UPDATE|DROP|SCRIPT|ALERT|ONERROR)/i;
    if (blacklist.test(input)) return false;
  
    return true;
  }
  downloadJSONToCSV(datas: string, filename: string = 'responseresult.csv'): void {
      var data = JSON.parse(datas);
    if (!data || !data.length) {
      console.warn('No data to export');
      return;
    }
  
    // Extract headers from first object
    const headers = Object.keys(data[0]);
  
    // Build CSV rows
    const csvRows: string[] = [];
  
    // Add header row
    csvRows.push(headers.join(','));
  
    // Add data rows
    for (const item of data) {
      const row = headers.map(header => {
        let val = item[header] ?? ''; // handle null/undefined
        val = String(val).replace(/"/g, '""'); // escape double quotes
        return `"${val}"`;
      });
      csvRows.push(row.join(','));
    }
  
    // Create CSV string
    const csvString = csvRows.join('\n');
  
    // Create Blob for download
    const blob = new Blob([csvString], { type: 'text/csv;charset=utf-8;' });
    const url = window.URL.createObjectURL(blob);
  
    // Create link element and trigger download
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  }
  isCSVDownloadableFromJSON(jsonString: string): boolean {
    try {
      // 1️⃣ Parse JSON safely
      const data = JSON.parse(jsonString);
  
      // 2️⃣ Must be an array
      if (!Array.isArray(data) || data.length === 0) {
        console.warn("❌ JSON is not a valid non-empty array.");
        return false;
      }
  
      // 3️⃣ Each item must be a plain object
      const isObjectArray = data.every(
        (item) => item && typeof item === "object" && !Array.isArray(item)
      );
      if (!isObjectArray) {
        console.warn("❌ JSON must contain plain objects only.");
        return false;
      }
  
      // 4️⃣ Each object must have at least one key
      const hasKeys = data.every((obj) => Object.keys(obj).length > 0);
      if (!hasKeys) {
        console.warn("❌ Some objects have no properties.");
        return false;
      }
  
      // ✅ All checks passed
      return true;
    } catch (error) {
      console.error("❌ Invalid JSON format:", error);
      return false;
    }
  }

convertJsonToHtml(data: any): string {

  const styleBlock = `
    <style>
      .json-wrapper {
        height: 200px;
        width: 100%;
        overflow: hidden; /* prevent double scrollbars */
        font-family: Arial, Helvetica, sans-serif;
        font-size: 14px;
      }

      /* Table and fixed header styling */
      .json-table {
        width: 100%;
        border-collapse: collapse;
      }

      .json-table thead {
        position: sticky;
        top: 0;
        background: #fff;
        z-index: 5;
      }

      .json-table th,
      .json-table td {
        border: 1px solid #000;
        padding: 8px;
        white-space: nowrap;
        text-align: left;
        vertical-align: top;
      }

      /* Scrollable body only */
      .json-scroll-body {
        max-height: 200px;
        overflow-y: auto;
        overflow-x: auto;
        display: block;
      }

      /* Force table columns to align in scroll-body */
      .json-scroll-body table {
        width: 100%;
        border-collapse: collapse;
      }

      /* List for primitive arrays */
      .json-list {
        margin: 6px 0 6px 15px;
      }
    </style>
  `;

  return styleBlock + this.generateJsonHtml(data);
}
generateJsonHtml(data: any): string {

  if (data === null || data === undefined) {
    return "<span>null</span>";
  }

  if (typeof data !== "object") {
    return `<span>${data}</span>`;
  }

  // ARRAY
  if (Array.isArray(data)) {

    // Primitive array → list
    if (data.every(x => typeof x !== "object")) {
      return `<ul class="json-list">${data.map(i => `<li>${i}</li>`).join("")}</ul>`;
    }

    // Array of objects → table with fixed header
    const headers = Object.keys(data[0] || {});

    return `
      <div class="json-wrapper">
        <div class="json-scroll-body">
          <table class="json-table">
            <thead>
              <tr>${headers.map(h => `<th>${h}</th>`).join("")}</tr>
            </thead>

            <tbody>
              ${data.map(row => `
                <tr>
                  ${headers.map(col => `
                    <td>${this.generateJsonHtml(row[col])}</td>
                  `).join("")}
                </tr>
              `).join("")}
            </tbody>

          </table>
        </div>
      </div>
    `;
  }

  // OBJECT → table
  return `
    <div class="json-wrapper">
      <div class="json-scroll-body">
        <table class="json-table">
          <thead>
            <tr><th>Key</th><th>Value</th></tr>
          </thead>

          <tbody>
            ${Object.keys(data).map(key => `
              <tr>
                <th>${key}</th>
                <td>${this.generateJsonHtml(data[key])}</td>
              </tr>
            `).join("")}
          </tbody>

        </table>
      </div>
    </div>
  `;
}

  copyCode(code: string) {
  navigator.clipboard.writeText(code.trim());
}
  GOtoNExtPage_2() {
    
    this.router.navigateByUrl('/operational-concern');
  }
  GOtoNExtPage_1() {
    
    this.router.navigateByUrl('/dashboard');
  }
  GOtoNExtPage_P()
  {
    this.router.navigateByUrl('/operational-concern1');
  }
  GOtomessage() {
      
    this.router.navigateByUrl('/messages');
  }
  
  go_config()
  {
    this.router.navigateByUrl('/mle-training');
  
  }
  gotomle(){
    this.router.navigateByUrl('/pricemodelcal');

  }
//    convertToHtml(text) {
//     // Convert inline numbered items: "1) item 2) item"
//     text = text.replace(/(\d+[\)\.])\s*/g, '\n$1 ');

//     // Convert inline bullets: "- item * item"
//     text = text.replace(/([-\*\u2022])\s+/g, '\n$1 ');

//     const lines = text.split('\n');
//     let html = '';
//     let listType = null;

//     lines.forEach(raw => {
//         const line = raw.trim();
//         if (!line) return;

//         const numbered = line.match(/^(\d+)[\.\)]\s+(.*)$/);
//         const bulleted = line.match(/^[-\*\u2022]\s+(.*)$/);

//         if (numbered) {
//             if (listType !== 'ol') {
//                 if (listType) html += `</${listType}>`;
//                 html += '<ol>';
//                 listType = 'ol';
//             }
//             html += `<li>${numbered[2]}</li>`;
//         }
//         else if (bulleted) {
//             if (listType !== 'ul') {
//                 if (listType) html += `</${listType}>`;
//                 html += '<ul>';
//                 listType = 'ul';
//             }
//             html += `<li>${bulleted[1]}</li>`;
//         }
//         else {
//             if (listType) { html += `</${listType}>`; listType = null; }
//             html += `<p>${line}</p>`;
//         }
//     });

//     if (listType) html += `</${listType}>`;
//     return html;
// }
}
